import { AVAILABLE_LANGS } from "@typings/globals";

//en
import imgMobileEn from "./assets/mobile/1.1_EN.webp";
import imgTabletEn from "./assets/tablet/1.1_EN.webp";
import imgDesktopEn from "./assets/desktop/1.1_EN.webp";
import imgLargeDesktopEn from "./assets/largeDesktop/1.1_EN.webp";
//de
import imgMobileDe from "./assets/mobile/1.1_DE.webp";
import imgTabletDe from "./assets/tablet/1.1_DE.webp";
import imgDesktopDe from "./assets/desktop/1.1_DE.webp";
import imgLargeDesktopDe from "./assets/largeDesktop/1.1_DE.webp";
//it
import imgMobileIt from "./assets/mobile/1.1_IT.webp";
import imgTabletIt from "./assets/tablet/1.1_IT.webp";
import imgDesktopIt from "./assets/desktop/1.1_IT.webp";
import imgLargeDesktopIt from "./assets/largeDesktop/1.1_IT.webp";
//fr
import imgMobileFr from "./assets/mobile/1.1_FR.webp";
import imgTabletFr from "./assets/tablet/1.1_FR.webp";
import imgDesktopFr from "./assets/desktop/1.1_FR.webp";
import imgLargeDesktopFr from "./assets/largeDesktop/1.1_FR.webp";

export const mobileImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: imgMobileDe,
    [AVAILABLE_LANGS.FR]: imgMobileFr,
    [AVAILABLE_LANGS.IT]: imgMobileIt,
  };

  return language in images ? images[language] : imgMobileEn;
};

export const tabletImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: imgTabletDe,
    [AVAILABLE_LANGS.FR]: imgTabletFr,
    [AVAILABLE_LANGS.IT]: imgTabletIt,
  };

  return language in images ? images[language] : imgTabletEn;
};

export const desktopImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: imgDesktopDe,
    [AVAILABLE_LANGS.FR]: imgDesktopFr,
    [AVAILABLE_LANGS.IT]: imgDesktopIt,
  };

  return language in images ? images[language] : imgDesktopEn;
};

export const largeDesktopImage = (language: AVAILABLE_LANGS) => {
  const images: { [key in AVAILABLE_LANGS]?: string } = {
    [AVAILABLE_LANGS.DE]: imgLargeDesktopDe,
    [AVAILABLE_LANGS.FR]: imgLargeDesktopFr,
    [AVAILABLE_LANGS.IT]: imgLargeDesktopIt,
  };

  return language in images ? images[language] : imgLargeDesktopEn;
};
